<template>
  <div class="play-status" :class="['play-'+type, 'play-'+ size ]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'PlayStatus',
  props: {
    size: {
      type: String,
      default: 'small' // default small
    },
    type: {
      type: String,
      default: 'success' // success error warning info disabled
    }
  }
}
</script>
<style lang="scss" scoped>
.play-status{
  display: inline-block;
  height: 24px;
  padding: 0 7px;
  line-height: 30px;
  font-size: 12px;
  box-sizing: border-box;
  white-space: nowrap;
  border-radius: 2px;
  &.play-default{
    height: 32px;
    line-height: 30px;
  }
  &.play-small{
    height: 24px;
    line-height: 22px;
  }
  &.play-success{
    background: rgba(35, 189, 204, 0.1);
    border: 1px solid #23BDCC;
    color: #23BDCC;
  }
  &.play-green{
    background: rgba(76, 189, 17, 0.1);
    border: 1px solid #4CBD11;
    color: #4CBD11;
  }
  &.play-primary{
    background: rgba(52, 140, 255, 0.1);
    border: 1px solid #348CFF;
    color: #348CFF;
  }
  &.play-error{
    background: rgba(242, 85, 85, 0.1);
    border: 1px solid #F25555;
    color: #F25555;
  }
  &.play-warning{
    background: rgba(255, 196, 47, 0.1);
    border: 1px solid #FFC42F;
    color: #FFC42F;
  }
  &.play-violet{
    background: #F3EAFC;
    border: 1px solid #A256EC;
    color: #A256EC;
  }
  &.play-info{
    background: rgba(204, 204, 204, 0.1);
    border: 1px solid #999999;
    color: #999999;
  }
  &.play-disabled{
    background: rgba(153, 153, 153, 0.1);
    border: 1px solid #CCCCCC;
    color: #CCCCCC;
  }
}
</style>
